var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import requestNcodeGzip_example from "../../ncodepod/PODv2/requestNcodeImage_example";
import { g_defaultNcode, g_defaultOverlayNcode, g_defaultTemporaryNcode, nullNcode } from "../constants";
import { EventDispatcher } from "../event";
import { NeoPdfManager, PdfManagerEventName } from "../neopdf";
import { getNPaperInfo, getNPaperSize_pu } from "../noteserver";
import { generateTempPaperTypeFromPdf, generateTempPaperTypeFromSize } from "../noteserver/NcodeSurfaceDataJson";
import { TransformParameters } from "../structures";
import { availablePagesInSection, cloneObj, convertNuToPu, getNextNcodePage, getNowTimeStr, isSamePage, makeNPageIdStr, makePdfId } from "../util";
import CoordinateTanslater from "./CoordinateTanslater";
import { MappingItem } from "./MappingItem";
import { getUniqueNcode } from "./unique_ncode/getIssuedCode";
export const BASECODE_PAGES_PER_SHEET = 16384;
export var MappingStorageEventName;
(function (MappingStorageEventName) {
    MappingStorageEventName["ON_MAPINFO_REFRESHED"] = "on_map_refreshed";
    MappingStorageEventName["ON_MAPINFO_ADDED"] = "on_map_changed";
    MappingStorageEventName["ON_PDF_UPDATED"] = "on_pdf_updated";
})(MappingStorageEventName || (MappingStorageEventName = {}));
const _debug = false;
let _ms_i = null;
const LOCAL_STORAGE_ID = "GridaBoard_codeMappingInfo_v2";
/**
 *
 */
export class MappingStorage {
    get rawData() {
        return this._data;
    }
    get rawDataTemp() {
        return this._temporary;
    }
    constructor() {
        /** 프로그램 실행이 끝나도 저장되어야 하는 mapping table */
        this._data = {
            nextIssuable: Object.assign({}, g_defaultNcode),
            arrDocMap: []
        };
        /** 프로그램이 실행되는 동안만 유지되는 mapping table */
        this._temporary = {
            nextIssuable: Object.assign({}, g_defaultTemporaryNcode),
            arrDocMap: []
        };
        /** 2021/08/25 오버레이를 위한 것 */
        this._overlayMap = {
            nextIssuable: Object.assign({}, g_defaultOverlayNcode),
            arrDocMap: []
        };
        this.dispatcher = new EventDispatcher();
        /**
         * PDF가 load되었으면, fingerprint에서 undefined로 된 것을 update해 준다
         * 2021/06/06 kitty
         *
         * @param event
         */
        this.onPdfLoaded = (event) => {
            console.log(`PDF LOADING: MSI catch the message ${event.pdf.filename}`);
            const found = this._data.arrDocMap.find(m => m.url === event.pdf.url);
            if (found) {
                const id_arr = found.id.split("/");
                found.id = event.pdf.fingerprint + "/" + id_arr[1];
                console.log("pdf loaded", found);
            }
            this.dispatcher.dispatch(MappingStorageEventName.ON_PDF_UPDATED, { status: "pdf updated", pdf: event.pdf, docMap: found });
        };
        this.initNextIssuable = () => {
            if (this._data.nextIssuable.section === -1) {
                this.nextIssuable = g_defaultNcode;
            }
        };
        this.reset = () => {
            this._data = {
                nextIssuable: Object.assign({}, g_defaultNcode),
                arrDocMap: [],
            };
        };
        /**
         * PDF fingerprint와 pagesPerSheet로 mapping된 ncode를 찾는다
         *
         * 이 함수를 dialog로 수정함으로써 프린터 옵션을 바꿀 수 있다
         * @param {string} fingerprint
         * @param {number} pagesPerSheet
         * @param {number} docNumPages
         * @memberof MappingStorage
         */
        this.getAssociatedMappingInfo = (fingerprint, pagesPerSheet, docNumPages) => {
            const theSames = this.findAssociatedPrintNcode(fingerprint, pagesPerSheet);
            const theSame = theSames.length > 0 ? theSames[0] : undefined;
            return theSame;
        };
        /**
         * pageInfo에서 PDF page를 찾는다
         * @param {IPageSOBP} pageInfo
         * @memberof MappingStorage
         */
        this.getAssociatedPdfPage = (pageInfo) => {
            return this.findPdfPage(pageInfo);
        };
        /**
         *  이 함수가 불려지기 전에, printOption에는 다음과 같은 항목이 설정되어 있어야만 한다.
         * * url, filename, fingerprint, pagesperSheet, docNumPages
         *
         * 이 리턴 값은 printOption으로 바로 들어가서 대체될 수 있다.
         * * printOption = {...printOption, ...returnValue }
         * * 또는, for (const key in returnValue) printOption[key] = returnValue[key];
         */
        this.getCodePrintInfo = (printOption, forceToUpdateBaseCode) => {
            if (forceToUpdateBaseCode === undefined)
                forceToUpdateBaseCode = printOption.forceToUpdateBaseCode;
            const { fingerprint, pagesPerSheet, docNumPages } = printOption;
            let needToIssueBaseCode;
            let needToIssuePrintCode;
            let basePageInfo;
            let printPageInfo;
            let prevBasePageInfo = nullNcode();
            let prevPrintPageInfo = nullNcode();
            let baseCodeIssued = false;
            /** 코드 할당에 대한 기본 값을 써 주자 */
            const theBase = this.findAssociatedBaseNcode(fingerprint);
            const theSames = this.findAssociatedPrintNcode(fingerprint, pagesPerSheet);
            const theSame = theSames.length > 0 ? theSames[0] : undefined;
            let codeDelta = 0;
            // base 코드 재활용 또는 할당
            if (theBase)
                prevBasePageInfo = Object.assign({}, theBase.basePageInfo);
            if (theBase && !forceToUpdateBaseCode) {
                // 재활용할 수 있는 경우
                needToIssueBaseCode = false;
                basePageInfo = Object.assign({}, theBase.basePageInfo);
            }
            else {
                // 할당해야만 하는 경우
                if (!theBase)
                    needToIssueBaseCode = true;
                // 2022/03/22
                let nextCode;
                if (printOption.forceToUseStartSobp) {
                    // 주어진 값으로 설정
                    nextCode = Object.assign({}, printOption.forceToUseStartSobp);
                }
                else {
                    // local에서 발행
                    nextCode = getNextNcodePage(this.nextIssuable, codeDelta);
                }
                basePageInfo = Object.assign({}, nextCode);
                baseCodeIssued = true;
                codeDelta += docNumPages;
            }
            // 인쇄될 페이지의 코드 재활용 또는 할당
            if (theSame)
                prevPrintPageInfo = Object.assign({}, theSame.printPageInfo);
            const reUsable = (!!theSame) && isSamePage(theSame.basePageInfo, theBase.basePageInfo);
            if (reUsable && !forceToUpdateBaseCode) {
                // 재활용할 수 있는 경우
                needToIssuePrintCode = false;
                printPageInfo = Object.assign({}, theSames[0].printPageInfo);
            }
            else {
                // 할당해야만 하는 경우
                if (!(theSames.length > 0))
                    needToIssuePrintCode = true;
                // 2022/03/22
                let nextCode;
                if (printOption.forceToUseStartSobp) {
                    // 주어진 값으로 설정
                    nextCode = Object.assign({}, printOption.forceToUseStartSobp);
                }
                else {
                    // local에서 발행
                    nextCode = getNextNcodePage(this.nextIssuable, codeDelta);
                }
                printPageInfo = Object.assign({}, nextCode);
                codeDelta += docNumPages;
            }
            return {
                prevBasePageInfo,
                needToIssueBaseCode,
                basePageInfo,
                baseCodeIssued,
                prevPrintPageInfo,
                needToIssuePrintCode,
                printPageInfo,
                numNcodeComsumed: codeDelta,
            };
        };
        this.getNextIssuablePageInfo = (printOption) => {
            const codeInfo = this.getCodePrintInfo(printOption, true);
            return [codeInfo.basePageInfo, codeInfo.printPageInfo];
        };
        this.makeDummyParamsForBasePageInfo = (arg) => {
            // const { docNumPages: numPages, fingerprint, url, filename } = printOption;
            const { basePageInfo, url, filename, fingerprint, numPages, background_image_url_rule, isPod, pdfDoc, shouldGetPaperInfoFromPdf, size_pu } = arg;
            // dummy
            const pages = [];
            for (let i = 0; i < numPages; i++) {
                const pageNo = i + 1;
                const mapData = new MappingItem(pageNo); // h의 기본값은 여기서 세팅된다.
                let pi;
                if (shouldGetPaperInfoFromPdf) {
                    pi = generateTempPaperTypeFromPdf(basePageInfo, pdfDoc, i);
                }
                // 2021/08/25, Overlay를 위해
                else if (size_pu) {
                    pi = generateTempPaperTypeFromSize(basePageInfo, size_pu, i);
                }
                else {
                    pi = getNPaperInfo(basePageInfo);
                }
                const paperSize_pu = getNPaperSize_pu(pi);
                // dummy Ncode page info
                const { Xmin: x0, Xmax: x1, Ymin: y0, Ymax: y1 } = pi.margin;
                // 아래 부분은 고쳐야 한다. kitty, 2021/01/02
                const rect = { unit: "nu", x: x0, y: y0, width: x1 - x0, height: y1 - y0 };
                const npageArea = [{ x: x0, y: y0 }, { x: x1, y: y0 }, { x: x1, y: y1 }, { x: x0, y: y1 }];
                let page = basePageInfo.page + i;
                if (isPod) {
                    const maxPages = availablePagesInSection(basePageInfo.section);
                    page = (page + maxPages) % maxPages;
                }
                const printPageInfo = Object.assign(Object.assign({}, basePageInfo), { page });
                const basePageInfo_for_page = Object.assign(Object.assign({}, basePageInfo), { page });
                mapData.setNcodeArea({ pageInfo: printPageInfo, basePageInfo: basePageInfo_for_page, rect, npageArea });
                // dummy PDF page info
                const pdfPageInfo = {
                    url, filename, fingerprint,
                    id: makePdfId(fingerprint, BASECODE_PAGES_PER_SHEET),
                    numPages, pageNo,
                    size_pu: paperSize_pu,
                };
                mapData.setPdfArea({ pdfPageInfo, rect: { unit: "pu", x: 0, y: 0, width: paperSize_pu.width, height: paperSize_pu.height } });
                pages.push(mapData._page);
            }
            const basePdfToNcodeMap = {
                url,
                filename,
                fingerprint,
                pagesPerSheet: BASECODE_PAGES_PER_SHEET,
                id: makePdfId(fingerprint, BASECODE_PAGES_PER_SHEET),
                numPages,
                background_image_url_rule,
                printPageInfo: Object.assign({}, basePageInfo),
                basePageInfo: Object.assign({}, basePageInfo),
                pages: pages,
                timeString: getNowTimeStr(),
                // 2021/08/12
                // pdfDoc: null,
            };
            return basePdfToNcodeMap;
        };
        /**
         * 서버로 부터 유니크 코드 받아오기
         *
         * @param {IPrintOption} printOption
         * @memberof MappingStorage
         */
        this.issueNcode_unique = (printOption) => __awaiter(this, void 0, void 0, function* () {
            const background_image_url_rule = null;
            // 리턴 값을 준비
            const { docNumPages, pagesPerSheet, fingerprint, url, filename } = printOption;
            try {
                // const { baseSobp, ncodeUrls, sobps } = await getUniqueNcode(printOption);
                // 2022/03/22
                let baseSobp;
                let sobp_and_urls;
                if (!printOption.forceToUseStartSobp) {
                    const unique = yield getUniqueNcode(printOption);
                    baseSobp = unique.baseSobp;
                    sobp_and_urls = unique.sobp_and_urls;
                }
                else {
                    // 2022/03/22에서 추가된 것, 임의의 sobp를 읽어올 수 있게
                    baseSobp = printOption.forceToUseStartSobp;
                    sobp_and_urls = new Array(docNumPages);
                    for (let i = 0; i < docNumPages; i++) {
                        sobp_and_urls[i] =
                            {
                                url: undefined,
                                sobp: Object.assign(Object.assign({}, baseSobp), { page: baseSobp.page + i }),
                            };
                        console.log(`request ${i + 1}/${docNumPages}, sobp:${makeNPageIdStr(sobp_and_urls[i].sobp)}`);
                        const gz = yield requestNcodeGzip_example(sobp_and_urls[i].sobp, printOption.mediaSize);
                        const url = URL.createObjectURL(gz.gzippedBlob);
                        sobp_and_urls[i].url = url;
                    }
                }
                // 여기까지
                // 로컬 매핑 스토리지에 등록? 이것 필요할까? kitty 2021/06/08
                const basePdfToNcodeMap = this.makeDummyParamsForBasePageInfo(
                // codeNeeded.basePageInfo, url, filename, fingerprint, docNumPages, background_image_url_rule, true);
                {
                    basePageInfo: baseSobp,
                    url: url,
                    filename: filename,
                    fingerprint: fingerprint,
                    pdfDoc: undefined,
                    numPages: docNumPages,
                    background_image_url_rule,
                    isPod: true
                });
                // baseSobp,
                // url, filename, fingerprint, docNumPages, background_image_url_rule,
                // true
                this._data.arrDocMap.push(basePdfToNcodeMap);
                // 현재 인쇄 상태의 map의 코드 정보를 전달
                const pdfToNcodeMap = {
                    url,
                    filename,
                    fingerprint,
                    pagesPerSheet,
                    id: makePdfId(fingerprint, pagesPerSheet),
                    numPages: docNumPages,
                    printPageInfo: Object.assign({}, baseSobp),
                    basePageInfo: Object.assign({}, baseSobp),
                    background_image_url_rule,
                    pages: undefined,
                    timeString: getNowTimeStr(),
                    ncodeUrls: sobp_and_urls === null || sobp_and_urls === void 0 ? void 0 : sobp_and_urls.map(item => item.url),
                    sobps: sobp_and_urls === null || sobp_and_urls === void 0 ? void 0 : sobp_and_urls.map(item => item.sobp),
                    // 2021/08/12
                    // pdfDoc: null,
                };
                return pdfToNcodeMap;
            }
            catch (e) {
                // 현재 인쇄 상태의 map의 코드 정보를 전달
                const pdfToNcodeMap = {
                    url,
                    filename,
                    fingerprint,
                    pagesPerSheet,
                    id: makePdfId(fingerprint, pagesPerSheet),
                    numPages: docNumPages,
                    printPageInfo: undefined,
                    basePageInfo: undefined,
                    background_image_url_rule,
                    pages: undefined,
                    timeString: getNowTimeStr(),
                    ncodeUrls: undefined,
                    sobps: undefined,
                    // 2021/08/12
                    // pdfDoc: null,
                };
                return pdfToNcodeMap;
            }
        });
        /**
         * Local 코드 영역을 할당하고, 발행한다
         *
         * @param {IPrintOption} printOption
         * @memberof MappingStorage
         */
        this.issueNcode = (printOption) => __awaiter(this, void 0, void 0, function* () {
            const background_image_url_rule = null;
            // 한번도 코드를 발행해 본적이 없는 경우의 default
            this.initNextIssuable();
            // 리턴 값을 준비
            const { docNumPages, pagesPerSheet, fingerprint, url, filename } = printOption;
            const codeNeeded = this.getCodePrintInfo(printOption, undefined);
            // Base map을 등록해야 한다면, 아래와 같이 더미의 base code map을 등록
            // 아래의 맵에서는 h가 정의되어 있지 않으므로, 직접 불러서 transform할 수 없다
            if (codeNeeded.baseCodeIssued) {
                // if (!fingerprint) throw new Error("fingerprint not provided");
                const basePdfToNcodeMap = this.makeDummyParamsForBasePageInfo({
                    basePageInfo: codeNeeded.basePageInfo,
                    url: url,
                    filename: filename,
                    fingerprint: fingerprint,
                    pdfDoc: undefined,
                    numPages: docNumPages,
                    background_image_url_rule,
                    isPod: true
                });
                // codeNeeded.basePageInfo, url, filename, fingerprint, docNumPages, background_image_url_rule, true);
                this._data.arrDocMap.push(basePdfToNcodeMap);
            }
            // 현재 인쇄 상태의 map의 코드 정보를 전달
            const pdfToNcodeMap = {
                url,
                filename,
                fingerprint,
                pagesPerSheet,
                id: makePdfId(fingerprint, pagesPerSheet),
                numPages: docNumPages,
                printPageInfo: Object.assign({}, codeNeeded.printPageInfo),
                basePageInfo: Object.assign({}, codeNeeded.basePageInfo),
                background_image_url_rule,
                pages: undefined,
                timeString: getNowTimeStr(),
                ncodeUrls: undefined,
                sobps: MappingStorage.makeAssignedNcodeArray(codeNeeded.printPageInfo, docNumPages),
                // 2021/08/12
                // pdfDoc: null,
            };
            this.nextIssuable = getNextNcodePage(this.nextIssuable, codeNeeded.numNcodeComsumed);
            return pdfToNcodeMap;
        });
        this.calcHfromNote = (arg) => {
            const { Xmin: x0, Ymin: y0, Xmax: x1, Ymax: y1, pageNo } = arg;
            if (x1 === undefined || y1 === undefined) {
                const h = new TransformParameters();
                return h;
            }
            const mapData = new MappingItem(pageNo);
            const w_nu = x1 - x0;
            const h_nu = y1 - y0;
            const w_pu = convertNuToPu(w_nu);
            const h_pu = convertNuToPu(h_nu);
            const srcPoints = [{ x: x0, y: y0 }, { x: x1, y: y0 }, { x: x1, y: y1 }, { x: x0, y: y1 }];
            const dstPoints = [{ x: 0, y: 0 }, { x: w_pu, y: 0 }, { x: w_pu, y: h_pu }, { x: 0, y: h_pu }];
            mapData.setSrc4Points_ncode(srcPoints);
            mapData.setDst4Points_pdf(dstPoints);
            const trans = new CoordinateTanslater();
            const h = trans.calc(mapData);
            return h;
        };
        this.getNPageTransform = (pageInfo) => {
            let h;
            const ret = {
                type: undefined,
                pageInfo: undefined,
                basePageInfo: undefined,
                h: undefined,
                pdf: {
                    url: undefined,
                    filename: undefined,
                    fingerprint: undefined,
                    numPages: undefined,
                    pdfPageNo: undefined,
                    pagesPerSheet: undefined,
                }
            };
            // 1) Ncode 페이지 맵에 있는지 확인한다.
            const noteItem = getNPaperInfo(pageInfo);
            if (!noteItem.isDefault) {
                h = this.calcHfromNote(Object.assign(Object.assign({}, noteItem.margin), { pageNo: pageInfo.page }));
                ret.h = h;
                ret.type = "note";
                ret.pageInfo = pageInfo;
                ret.basePageInfo = pageInfo;
                ret.pdf.filename = noteItem.pdf_name;
                return ret;
            }
            // 2) Mapping된 PDF 페이지인지 확인한다.
            // const pdfItem = this.findPdfPage({ ...pageInfo, x: 10, y: 10 });
            const pdfItem = this.getAssociatedPdfPage(pageInfo);
            if (pdfItem) {
                const pageMap = pdfItem.pageMapping;
                ret.h = pageMap.h;
                ret.type = "pod";
                ret.pageInfo = pageMap.pageInfo;
                ret.basePageInfo = pageMap.basePageInfo;
                ret.pdf = {
                    url: pdfItem.pdf.url,
                    filename: pdfItem.pdf.filename,
                    fingerprint: pdfItem.pdf.fingerprint,
                    numPages: pdfItem.pdf.numPages,
                    pdfPageNo: pageMap.pdfPageNo,
                    pagesPerSheet: pdfItem.pdf.pagesPerSheet,
                };
                return ret;
            }
            // 3) 아니면 그냥 A4를 리턴한다.
            const defaultItem = getNPaperInfo({ section: -1, owner: -1, book: -1, page: -1 });
            h = this.calcHfromNote(Object.assign(Object.assign({}, defaultItem.margin), { pageNo: pageInfo.page }));
            ret.h = h;
            ret.type = "default";
            ret.pageInfo = pageInfo;
            ret.basePageInfo = pageInfo;
            return ret;
        };
        /**
         * mapping되지 않은 PDF나, ncode 공책들의 임시 mapping table을 생성하고 돌려주는 주고
         */
        this.makeTemporaryAssociateMapItem = (option) => {
            const { pdf, n_paper, numBlankPages, background_image_url_rule, size_pu } = option;
            if (!pdf && !n_paper && !numBlankPages) {
                console.error("n_paper neighter pdf has not been given to makeTemporaryAssociateMapItem ");
                return undefined;
            }
            // 2021/08/04 kitty, n_paper로 SOBP가 주어지면 따로 로컬에서 임시 코드를 가져오지 않는다.
            const nextLocalCode = getNextNcodePage(this._temporary.nextIssuable, 0);
            const nextCode = n_paper ? n_paper : nextLocalCode;
            let basePdfToNcodeMap;
            if (pdf) {
                const { url, filename, fingerprint, numPages } = pdf.pdfDoc;
                // 매핑되지 않은 PDF를 추가
                if (isSamePage(nextLocalCode, n_paper)) {
                    this._temporary.nextIssuable = getNextNcodePage(this._temporary.nextIssuable, pdf.numPages);
                }
                basePdfToNcodeMap = this.makeDummyParamsForBasePageInfo({
                    basePageInfo: nextCode,
                    // url: pdf.url,
                    // filename: pdf.filename,
                    // fingerprint: pdf.fingerprint,
                    // numPages: pdf.numPages,
                    url, filename, fingerprint, numPages,
                    pdfDoc: pdf.pdfDoc,
                    shouldGetPaperInfoFromPdf: true,
                    background_image_url_rule,
                    isPod: true
                });
            }
            else if (n_paper) {
                // Ncode가 들어와서 추가되는 페이지
                const pi = getNPaperInfo(n_paper);
                const basePageInfo = Object.assign(Object.assign({}, n_paper), { page: pi.ncode_start_page });
                basePdfToNcodeMap = this.makeDummyParamsForBasePageInfo({
                    basePageInfo: basePageInfo,
                    url: pi.pdf_name,
                    filename: pi.pdf_name,
                    fingerprint: pi.pdf_name,
                    pdfDoc: pdf === null || pdf === void 0 ? void 0 : pdf.pdfDoc,
                    numPages: pi.pdf_page_count + 1,
                    background_image_url_rule,
                    isPod: false
                });
                // basePageInfo, pi.pdf_name, pi.pdf_name, pi.pdf_name, pi.pdf_page_count + 1, background_image_url_rule, false);
            }
            // 2021/08/25
            else if (size_pu) {
                let nextCode = size_pu.sobp;
                if (!nextCode) {
                    // sobp가 주어지지 않았으면 임시로 만든다
                    nextCode = size_pu.sobp ? size_pu.sobp : getNextNcodePage(this._overlayMap.nextIssuable, 0);
                    this._overlayMap.nextIssuable = getNextNcodePage(this._overlayMap.nextIssuable, numBlankPages);
                }
                basePdfToNcodeMap = this.makeDummyParamsForBasePageInfo({
                    basePageInfo: nextCode,
                    url: undefined,
                    filename: undefined,
                    fingerprint: undefined,
                    pdfDoc: undefined,
                    numPages: numBlankPages,
                    background_image_url_rule,
                    isPod: true,
                    size_pu
                });
            }
            else {
                //
                const nextCode = getNextNcodePage(this._temporary.nextIssuable, 0);
                this._temporary.nextIssuable = getNextNcodePage(this._temporary.nextIssuable, numBlankPages);
                const piBlank = getNPaperInfo(nullNcode());
                // if (!piBlank.pdf_name) throw new Error("fingerprint not provided");
                basePdfToNcodeMap = this.makeDummyParamsForBasePageInfo({
                    basePageInfo: nextCode,
                    url: piBlank.pdf_name,
                    filename: piBlank.pdf_name,
                    fingerprint: piBlank.pdf_name,
                    pdfDoc: pdf === null || pdf === void 0 ? void 0 : pdf.pdfDoc,
                    numPages: numBlankPages,
                    background_image_url_rule,
                    isPod: true
                });
                // nextCode, piBlank.pdf_name, piBlank.pdf_name, piBlank.pdf_name, numBlankPages, background_image_url_rule, true);
            }
            this._temporary.arrDocMap.unshift(basePdfToNcodeMap);
            this.dispatcher.dispatch(MappingStorageEventName.ON_MAPINFO_ADDED, { status: "new temp map added", pdf: pdf === null || pdf === void 0 ? void 0 : pdf.pdfDoc, docMap: basePdfToNcodeMap });
            return basePdfToNcodeMap;
        };
        /**
         * 오버레이에서만 쓰만 함수, temporary에 등록된 오버레이용 페이지의 사이즈를 수정할 때 쓴다
         * @param sobp
         * @param size_pu
         */
        this.changeMappedPdfPageSize = (arg) => {
            const { sobp, size_pu } = arg;
            const { pageMapping } = this.getAssociatedPdfPage(sobp);
            const { pdfDesc, npageArea } = pageMapping;
            const pu_to_nu_x = npageArea[2].x / pdfDesc.size_pu.width;
            const pu_to_nu_y = npageArea[2].y / pdfDesc.size_pu.height;
            pageMapping.pdfDesc.size_pu = {
                width: size_pu.width,
                height: size_pu.height
            };
            npageArea[2].x = size_pu.width * pu_to_nu_x;
            npageArea[2].y = size_pu.height * pu_to_nu_y;
            npageArea[1].x = size_pu.width * pu_to_nu_x;
            npageArea[3].y = size_pu.height * pu_to_nu_y;
            // H는 그대로 둔다
            // 페이지가 바뀌었다고 알려줍시다.
            this.dispatcher.dispatch(MappingStorageEventName.ON_MAPINFO_ADDED, { status: "new temp map added", pageMap: pageMapping });
        };
        this.register = (mapper) => {
            mapper.makeSummary();
            // 2021/08/12 중복되는 것은 지워주자
            const foundIndex = this._data.arrDocMap.findIndex((map) => (mapper.docMap.fingerprint === map.fingerprint
                && isSamePage(mapper.docMap.printPageInfo, map.printPageInfo)
                && mapper.docMap.numPages === map.numPages));
            const { docMap } = mapper;
            docMap.timeString = getNowTimeStr();
            if (foundIndex < 0) {
                // 이제 등록하자
                this._data.arrDocMap.unshift(docMap);
                this.dispatcher.dispatch(MappingStorageEventName.ON_MAPINFO_ADDED, { status: "new map added", docMap });
            }
            else {
                this._data.arrDocMap[foundIndex] = docMap;
            }
            // this.storeMappingInfo();
            if (_debug)
                this.dump("mapping");
        };
        // public getCloudData() {
        //   cloud_util_func.readMappingInfo();
        // }
        this.setTestStorage = (obj) => {
            this._testStorage = obj;
            console.log(this._testStorage);
        };
        // public saveOnCloud = () => {
        //   const params = {
        //     "IPageMapItem": {
        //       timeString: "1111",
        //       pageInfo: { section: "1", book: "1", owner: "1", page: "1" },
        //     }
        //   }
        //   const params2 = {
        //     "IPageMapItem": {
        //       timeString: "1111",
        //       pageInfo: { section: "1", book: "1", owner: "1", page: "2" },
        //     }
        //   }
        //   const lastCode = { section: "1", book: "1", owner: "1", page: "2" };
        //   const nextCode = { section: "1", book: "1", owner: "1", page: "3" };
        //   const mappingInfoObj = {
        //     "code": {
        //       "last": lastCode,
        //       "next": nextCode,
        //     },
        //     "map": [params, params2]
        //   }
        //   cloud_util_func.uploadMappingInfo(mappingInfoObj);
        // }
        /**
         * pen down시에 새로운 SOBP라면, 관련된 PDF가 있는지 찾을 때 쓰인다
         */
        this.findPdfPage = (sobp, xy = undefined) => {
            // 2021/08/18
            const { section: s, owner: o, book: b } = sobp;
            const pageIncluded = (m) => {
                const { section: s2, owner: o2, book: b2 } = m.printPageInfo;
                if (s !== s2 || o !== o2 || b !== b2)
                    return false;
                const pageFound = m.pages.find(p => isSamePage(sobp, p.pageInfo));
                return !!pageFound;
            };
            // 2021/08/18
            const found = this._data.arrDocMap.find(m => pageIncluded(m));
            // const found = this._data.arrDocMap.find(m => isPageInRange(ncodeXy, m.printPageInfo, m.numPages));
            if (found) {
                /** 원래는 폴리곤에 속했는지 점검해야 하지만, 현재는 같은 페이지인지만 점검한다  2020/12/06 */
                const pageMap = found.pages.find(param => isSamePage(sobp, param.pageInfo));
                return { pdf: found, pageMapping: pageMap };
            }
            // 2021/08/18
            const found_temporary = this._temporary.arrDocMap.find(m => pageIncluded(m));
            // const found_temporary = this._temporary.arrDocMap.find(m => isPageInRange(ncodeXy, m.printPageInfo, m.numPages));
            if (found_temporary) {
                /** 원래는 폴리곤에 속했는지 점검해야 하지만, 현재는 같은 페이지인지만 점검한다  2020/12/06 */
                const pageMap = found_temporary.pages.find(param => isSamePage(sobp, param.pageInfo));
                return { pdf: found_temporary, pageMapping: pageMap };
            }
            return undefined;
        };
        /**
         * Ncode가 발행된 적이 있는지를 점검하기 위해서 쓰인다.
         */
        this.findAssociatedNcode = (fingerprint, pagesPerSheet) => {
            const theBase = this.findAssociatedBaseNcode(fingerprint);
            const theSames = this.findAssociatedPrintNcode(fingerprint, pagesPerSheet);
            return { theBase, theSames };
        };
        this.findAssociatedPrintNcode = (fingerprint, pagesPerSheet) => {
            const id = makePdfId(fingerprint, pagesPerSheet);
            const theSames = this._data.arrDocMap.filter(m => id === m.id);
            // theSames.sort((a, b) => b.timeString > a.timeString ? 1 : (b.timeString === a.timeString ? 0 : -1));
            return theSames;
        };
        this.findAssociatedBaseNcode = (fingerprint) => {
            const baseId = makePdfId(fingerprint, BASECODE_PAGES_PER_SHEET);
            // const theBase = this._data.arrDocMap.find(m => baseId === m.id);
            const theBases = this._data.arrDocMap.filter(m => baseId === m.id);
            // theBases.sort((a, b) => b.timeString > a.timeString ? 1 : (b.timeString === a.timeString ? 0 : -1));
            const theBase = theBases.length > 0 ? theBases[0] : undefined;
            return theBase;
        };
        this.dump = (prefix) => {
            console.log(`[${prefix}]==============================================================================================================================`);
            this.dumpJson(prefix, this._data.nextIssuable);
            console.log(`[${prefix}]..............................................................................................................................`);
            for (let i = 0, l = this._data.arrDocMap.length; i < l; i++) {
                const item = this._data.arrDocMap[i];
                const clone = cloneObj(item);
                clone.params = null;
                this.dumpJson(prefix, clone);
                console.log(`[${prefix}]..............................................................................................................................`);
            }
            console.log(`[${prefix}]==============================================================================================================================`);
        };
        this.dumpJson = (prefix, obj) => {
            const str = JSON.stringify(obj, null, "  ");
            const arr = str.split("\n");
            for (let i = 0, l = arr.length; i < l; i++) {
                console.log(`[${prefix}] ${arr[i]}`);
            }
        };
        this.clear = () => {
            this.reset();
            this.storeMappingInfo();
            console.log("Mapping information cleared");
        };
        this.storeMappingInfo = () => {
            try {
                if (storageAvailable("localStorage")) {
                    const key = LOCAL_STORAGE_ID;
                    const value = JSON.stringify(this._data);
                    // console.log(`Pdf Ncode Info Saved   ${key}: ${value}`);
                    localStorage.setItem(key, value);
                    return true;
                }
                return false;
            }
            catch (e) {
                console.error(e);
                return false;
            }
        };
        this.addEventListener = (eventName, listener) => {
            this.dispatcher.on(eventName, listener, null);
        };
        /**
         *
         * @param eventName
         * @param listener
         */
        this.removeEventListener = (eventName, listener) => {
            this.dispatcher.off(eventName, listener);
        };
        /**
         * app이 기동되면 반드시 처음에 load하자
         *
         * @return {boolean}
         */
        this.loadMappingInfo = () => {
            if (storageAvailable("localStorage")) {
                const key = LOCAL_STORAGE_ID;
                const value = localStorage.getItem(key);
                if (value) {
                    this._data = JSON.parse(value);
                    // 최신순으로 소팅
                    this._data.arrDocMap.sort((a, b) => b.timeString > a.timeString ? 1 : (b.timeString === a.timeString ? 0 : -1));
                    // 개발중 코드, Data Structure가 바뀐 것이라면 reset kitty
                    const validStoredData = true;
                    // const found = this._data.arrDocMap.forEach(m => { if (!m.printPageInfo || !m.numPages) validStoredData = false; });
                    if (!validStoredData) {
                        alert(`MappingStorage reset`);
                        this.clear();
                    }
                    // this.dump("loading");
                    // const debug = JSON.stringify(this._arrMapped);
                    // console.log(`Pdf Ncode Info Loaded   ${key}: ${debug}`);
                    return true;
                }
            }
            return false;
        };
        if (_ms_i)
            return _ms_i;
        // https://www.bsidesoft.com/1426 , [js] localStorage 키별 용량 제약 처리
        // 이것 참고해서 더 수정할 것
        // this.loadMappingInfo();
        // PDF가 refresh 되면, 현재 page의 배경을 update해 줘야 할수도 있다. 2021/06/06
        const dm = NeoPdfManager.getInstance();
        dm.addEventListener(PdfManagerEventName.ON_PDF_LOADED, this.onPdfLoaded);
        this.initNextIssuable();
    }
    static getInstance() {
        if (_ms_i)
            return _ms_i;
        _ms_i = new MappingStorage();
        return _ms_i;
    }
    get nextIssuable() {
        return this._data.nextIssuable;
    }
    set nextIssuable(pageInfo) {
        this._data.nextIssuable = Object.assign({}, pageInfo);
    }
}
MappingStorage.makeAssignedNcodeArray = (startPage, numPages) => {
    const pages = [];
    for (let i = 0; i < numPages; i++) {
        const pi = getNextNcodePage(startPage, i);
        pages.push(pi);
    }
    return pages;
};
function storageAvailable(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return (e instanceof DOMException &&
            // Firefox를 제외한 모든 브라우저
            (e.code === 22 ||
                // Firefox
                e.code === 1014 ||
                // 코드가 존재하지 않을 수도 있기 떄문에 이름 필드도 확인합니다.
                // Firefox를 제외한 모든 브라우저
                e.name === "QuotaExceededError" ||
                // Firefox
                e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
            // 이미 저장된 것이있는 경우에만 QuotaExceededError를 확인하십시오.
            storage &&
            storage.length !== 0);
    }
}
//# sourceMappingURL=MappingStorage.js.map